import React from 'react';
import ApprovedRejectedPage from './rejected/ApprovedRejectedPage';

const ApprovalHistoryPage: React.FC = () => {
  return <ApprovedRejectedPage />;
};

export default ApprovalHistoryPage;